export default "__VITE_ASSET__WRLxuzEv__"